/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Codec_AacInputs */

const en_audio_embed_export_codec_aac = /** @type {(inputs: Audio_Embed_Export_Codec_AacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAC`)
};

const fr_audio_embed_export_codec_aac = /** @type {(inputs: Audio_Embed_Export_Codec_AacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAC`)
};

const de_audio_embed_export_codec_aac = /** @type {(inputs: Audio_Embed_Export_Codec_AacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAC`)
};

const it_audio_embed_export_codec_aac = /** @type {(inputs: Audio_Embed_Export_Codec_AacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAC`)
};

const ru_audio_embed_export_codec_aac = /** @type {(inputs: Audio_Embed_Export_Codec_AacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ААК`)
};

const es_audio_embed_export_codec_aac = /** @type {(inputs: Audio_Embed_Export_Codec_AacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CAA`)
};

const zh_cn2_audio_embed_export_codec_aac = /** @type {(inputs: Audio_Embed_Export_Codec_AacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`辅助空调系统`)
};

const ja_audio_embed_export_codec_aac = /** @type {(inputs: Audio_Embed_Export_Codec_AacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAC`)
};

const hi_audio_embed_export_codec_aac = /** @type {(inputs: Audio_Embed_Export_Codec_AacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एएसी`)
};

const pt_pt2_audio_embed_export_codec_aac = /** @type {(inputs: Audio_Embed_Export_Codec_AacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAC`)
};

/**
* | output |
* | --- |
* | "AAC" |
*
* @param {Audio_Embed_Export_Codec_AacInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_codec_aac = /** @type {((inputs?: Audio_Embed_Export_Codec_AacInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Codec_AacInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_codec_aac(inputs)
	if (locale === "de") return de_audio_embed_export_codec_aac(inputs)
	if (locale === "it") return it_audio_embed_export_codec_aac(inputs)
	if (locale === "ru") return ru_audio_embed_export_codec_aac(inputs)
	if (locale === "es") return es_audio_embed_export_codec_aac(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_codec_aac(inputs)
	if (locale === "ja") return ja_audio_embed_export_codec_aac(inputs)
	if (locale === "hi") return hi_audio_embed_export_codec_aac(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_codec_aac(inputs)
	return en_audio_embed_export_codec_aac(inputs)
});